import type { EnhancedProductFamilyId } from '#api/enhancements/enhancedTmsApiTypes'
import type { MarketDetails } from '#app/store/slices/configuration/marketSlice'
import { getFamilySelectionMetaData } from '#features/NationalCodes/selectionHelpers'
import { getAllVariants } from '#pages/Configuration/utils/collections'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

export function calculateTotalConfigurationPrice(
  productGroups: TruckConfiguration['productGroups'],
  marketDetails: MarketDetails | undefined,
  configuredFamilies: TruckConfiguration['configuredFamilies'] | undefined,
) {
  let totalPrice = 0

  const productsPrice = getAllVariants(productGroups)
    .filter((x) => !!x.isSelected)
    .map((x) => x.dummy_price)
    .filter((x) => x !== undefined)
    .reduce((a, b) => a + b, 0)

  totalPrice += productsPrice

  if (marketDetails) {
    const nationalCodesPrice = marketDetails.groups
      .flatMap((g) => g.families ?? [])
      .flatMap((f) => getFamilySelectionMetaData(f, configuredFamilies?.[f.familyId as EnhancedProductFamilyId])?.attributes?.grossListPrice ?? 0)
      .reduce((a, b) => a + b, 0)

    totalPrice += nationalCodesPrice
  }

  return totalPrice
}
